module.exports = __webpack_public_path__ + "static/the-compound-effect-4dfb761d9652789fcae34ac60895bfe5.jpg";